import {
  Ban,
  CalendarCheck,
  Check,
  TriangleAlert,
  UserX,
  Video,
  type LucideIcon,
} from "lucide-react";
import {
  MEETING_CALENDAR_STATUS_LABEL,
  type MeetingCalendarStatus,
} from "@care-by-ella/contracts";

// TES-1233 — Emelie: "Färg får inte vara enda statusbäraren. Status ska även
// framgå genom text eller ikon." Every status is an icon AND its word; the
// colour only repeats what they already say.
export const STATUS_ICON: Record<MeetingCalendarStatus, LucideIcon> = {
  booked: CalendarCheck,
  ongoing: Video,
  completed: Check,
  cancelled: Ban,
  patient_no_show: UserX,
  needs_rebooking: TriangleAlert,
};

const STATUS_TAG_CLASS: Record<MeetingCalendarStatus, string> = {
  booked: "bg-brand/10 text-brand-deep",
  ongoing: "bg-brand text-textOnBrand",
  completed: "bg-status-complete-fill text-status-complete-ink",
  cancelled: "bg-status-neutral-fill text-status-neutral-ink",
  patient_no_show: "bg-status-incomplete-fill text-status-incomplete-ink",
  needs_rebooking: "bg-status-risk-fill text-status-risk-ink",
};

export function MeetingStatusTag({
  status,
  compact = false,
}: {
  status: MeetingCalendarStatus;
  compact?: boolean;
}) {
  const Icon = STATUS_ICON[status];
  const label = MEETING_CALENDAR_STATUS_LABEL[status];
  return (
    <span
      className={`inline-flex items-center gap-xs rounded-pill px-sm py-[2px] text-xs font-medium ${STATUS_TAG_CLASS[status]}`}
    >
      <Icon aria-hidden className="h-3 w-3 shrink-0" />
      {compact ? <span className="sr-only">{label}</span> : label}
    </span>
  );
}
